import loadable from '@loadable/component';

export const MarieclaireusSiteWrapper = loadable(
  () => import(/* webpackChunkName: "marieclaireus-site" */ './MarieclaireusSiteWrapper'),
);
